export default "__VITE_PUBLIC_ASSET__771fb46b__"